<template>
    <div class="lb-comment">
        <article>
            <div>
                <div>
                    <p class="is-size-6">
                        <span class="pr-1">
                            <strong>{{
                                comment.owner.alias || comment.owner.username
                            }}</strong></span
                        ><span class="is-size-7">
                            {{ comment.modified | timeFormat }}
                        </span>
                        <span
                            v-if="comment.edited"
                            v-t="'App.content_edited'"
                            class="is-italic is-size-7"
                        >
                        </span>
                    </p>
                </div>
                <span
                    v-if="comment.deleted"
                    v-t="'App.comment_deleted'"
                    class="is-italic is-size-7"
                ></span>
            </div>
        </article>
        <app-editable-comment
            v-if="!comment.deleted"
            :message="comment.message"
            :editable="canEdit"
            :has-editor="hasEditor"
            :editionDisabled="editionDisabled"
            @edit="emitEdit"
            @delete="$emit('delete', $event)"
        />
    </div>
</template>
<script>
import moment from 'moment';
import AppEditableComment from '@/components/AppEditableComment';
export default {
    components: {
        AppEditableComment,
    },
    filters: {
        timeDifference(timestamp) {
            moment.locale('es'); // TODO use vue moment to better handle this
            // console.log();
            return moment(moment(timestamp), 'minutes').fromNow();
        },
        timeFormat(timestamp) {
            return moment(timestamp).format('DD/MM/YY HH:mm');
        },
    },
    props: {
        comment: {
            type: Object,
            default: () => {
                return {};
            },
        },
        object: {
            type: Object,
            default: () => {
                return {};
            },
        },
        hasEditor: {
            type: Boolean,
            default: false,
        },
        editionDisabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        canManage() {
            return (
                (this.comment.owner.owner === this.$store.getters.user.owner ||
                    this.object.owner.owner ===
                        this.$store.getters.user.owner) &&
                !this.comment.deleted
            );
        },
        canEdit() {
            return (
                this.comment.owner.owner === this.$store.getters.user.owner &&
                !this.comment.deleted
            );
        },
    },
    methods: {
        emitEdit(message) {
            this.comment.message = message;
            this.$emit('edit', this.comment);
        },
    },
};
</script>

<style scoped>
.lb-comment {
    transition: all 0.5s;
}
</style>
